import {ObjectOfAny} from '@fo/shared-types';

const youtubeUrl = 'https://www.youtube.com/embed/';

const patterns = {
  embed: '/embed/',
  watch: '/watch?v=',
  short: 'youtu.be/',
};

export const convertParams = (key: string, value: string): ObjectOfAny => {
  switch (key) {
    case 't':
      return {
        start: parseInt(value, 10).toString(),
      };
    default:
      return {
        [key]: value,
      };
  }
};

export const getParamsFromUrl = (url: string): string => {
  const params: ObjectOfAny =
    url
      .split('?')[1]
      ?.split('&')
      .reduce((accObj, item) => {
        const itemParams = item.split('=');
        return {
          ...accObj,
          ...convertParams(itemParams[0], itemParams[1]),
        };
      }, {}) || {};

  if (!params?.v) {
    if (url.includes(patterns.short)) {
      params.v = url.slice(
        url.indexOf(patterns.short) + patterns.short.length,
        url.includes('?') ? url.indexOf('?') : undefined
      );
    }
    if (url.includes(patterns.embed)) {
      params.v = url.slice(
        url.indexOf(patterns.embed) + patterns.embed.length,
        url.includes('?') ? url.indexOf('?') : undefined
      );
    }
  }

  return Object.entries(params).reduce((acc, item) => {
    if (item[0] === 'v') {
      return acc;
    }
    return `${acc === params.v ? `${acc}?` : `${acc}&`}${item[0]}=${item[1]}`;
  }, params.v);
};

export default (url: string): string => `${youtubeUrl}${getParamsFromUrl(url)}`;
